import { useWindowDimensions } from 'react-native';
import {
  getPointSlopeFn,
  makeLockedWidthFn,
  makeCoordinatePairFn,
  getLockRange,
} from './utils';
import type { CoordinatePair, LockRange } from './useFluidSize.types';

export const useLockFn = (lockedWidth: number) => {
  return (getCoordinates: (min: number, max: number) => CoordinatePair) => {
    return (min: number, max: number) => {
      const coordinatePair = getCoordinates(min, max);

      return getPointSlopeFn(coordinatePair)(lockedWidth);
    };
  };
};

const useLockedWidth = (config: typeof LockRange): number => {
  const { width } = useWindowDimensions();

  return makeLockedWidthFn(config)(width);
};

export const useFluidSize = (
  config?: typeof LockRange,
): ((min: number, max: number) => number) => {
  const lockRangeConfig = getLockRange(config);
  const lockedWidthWindow = useLockedWidth(lockRangeConfig);
  const getCoordinates = makeCoordinatePairFn(lockRangeConfig);

  return useLockFn(lockedWidthWindow)(getCoordinates);
};
